<template>
    <v-card :id="id" color="grey lighten-2 fill-height">
        <psi-card-heading
            :headingTitle="title"
            :icon="icon"
            :heading-color="headingColor"
        ></psi-card-heading>
        <v-card-text class="d-flex mt-2">
            <v-avatar size="60" class="mr-2">
                <img :src="student.profile_photo_url" height="24" width="24" />
            </v-avatar>
            <div>
                <div class="d-flex align-center mb-2">
                    <h3>
                        {{ student.name }}
                    </h3>
                    <v-chip
                        class="ml-2 text-uppercase accent--text text--darken-4"
                        small
                        color="accent lighten-3"
                        label
                        >{{ status }}</v-chip
                    >
                </div>
                <div class="d-flex">
                    <v-icon class="mr-2">mdi-email</v-icon>
                    <a :href="`mailto:${student.email}`">{{ student.email }}</a>
                </div>
                <div
                    class="d-flex mt-2"
                    v-if="$_.get(student, 'contact.phone', '')"
                >
                    <v-icon class="mr-2">mdi-phone</v-icon>
                    <a :href="`tel:${student.contact.phone}`">{{
                        student.contact.phone
                    }}</a>
                </div>
                <div
                    class="d-flex mt-2"
                    v-if="$_.get(student, 'meta.registered', false)"
                >
                    <v-icon class="mr-2">mdi-account-check</v-icon>
                    <span
                        >Registered on
                        <strong>
                            {{ student.created_at.split(" ").shift() }}</strong
                        ></span
                    >
                </div>
            </div>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="accent"
                class="mr-2"
                :to="{ name: 'Account Profile' }"
            >
                <v-icon class="mr-2">mdi-card-account-details</v-icon>
                Edit My Info
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import utils from "../library/programUtils";
export default {
    name: "student-info",
    components: {},
    props: {
        student: {
            type: Object,
            required: true,
        },
        title: {
            type: String,
            required: false,
            default: "Student",
        },
        icon: {
            type: String,
            required: false,
            default: "mdi-account-box",
        },
        headingColor: {
            type: String,
            required: false,
            default: "primary",
        },
        id: {
            type: String,
            required: false,
            default: "student-instructor",
        },
    },
    data() {
        return {};
    },
    computed: {
        status() {
            return utils.getStatus(this.$_.get(this.student, "order.status"));
        },
    },
};
</script>

<style scoped>
</style>